function nullToUndefined(value) {
  return value === null ? void 0 : value;
}
function map(array, fn) {
  return array.map(fn);
}
function mapValues(obj, callback) {
  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [key, callback(value, key)])
  );
}
function isNotNil(value) {
  return value != null;
}
function isNotEmpty(array) {
  return array.length >= 1;
}
function isTwoOrMoreElements(array) {
  return array.length >= 2;
}
function hasAllKeys(map2, keys) {
  if (keys.length !== map2.size)
    return false;
  for (const key of keys) {
    if (!map2.has(key))
      return false;
  }
  return true;
}
export {
  hasAllKeys,
  isNotEmpty,
  isNotNil,
  isTwoOrMoreElements,
  map,
  mapValues,
  nullToUndefined
};
//# sourceMappingURL=functional.js.map